import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSgpTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "2.5 1.8 71 36.6",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M45.2 14.3H49v1.2c1.2-1 2.7-1.5 4.4-1.5 4.1 0 7.3 3.4 7.3 7.8s-.7 3.9-1.9 5.2c-1.3 1.5-3.4 2.5-5.7 2.5s-2.8-.4-4-1.4v10.3h-4V14.3Zm4 9.6c.8 1.1 2.1 1.8 3.6 1.8 2.2 0 3.9-1.7 3.9-4.1s-1.5-4.1-3.8-4.1-2.9.7-3.7 1.8v4.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.9 21.7c0 7.3-5.7 13.2-12.7 13.2H53v3.5h1.2c8.9 0 16.1-7.5 16.1-16.7v-6.5h-3.5v6.5ZM5.9 21.7c0-7.3 5.7-13.2 12.7-13.2h41.7V5H18.6C9.7 5 2.5 12.5 2.5 21.7s7.2 16.7 16.1 16.7H24v-3.5h-5.4c-7 0-12.7-5.9-12.7-13.2",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7 18.5c0-.8.9-1.2 2-1.2s2.1.5 2.9 1l1.9-2.9c-1-.8-3.1-1.5-5-1.5-3 0-5.7 1.8-5.7 4.6 0 4.8 7.2 4 7.2 6.2s-.8 1.3-1.9 1.3-3.1-.6-4.1-1.5l-1.9 2.9c1.8 1.3 3.9 2 6 2 3.1 0 5.9-1.8 5.9-4.6 0-5.2-7.2-4.4-7.2-6.3ZM73.5 9.2l-2.4-2.4 2.4-2.5-2.4-2.5-2.5 2.5-2.4-2.5-2.5 2.5 2.5 2.4-2.5 2.5 2.5 2.5 2.4-2.5 2.5 2.5zM37.9 15.5c-1.2-1-2.7-1.5-4.4-1.5-4.1 0-7.3 3.4-7.3 7.8s.7 3.9 1.9 5.2c1.3 1.5 3.4 2.5 5.7 2.5s2.8-.4 4-1.4v2.7c0 1.5-.4 2.3-.9 2.9-.7.8-1.8 1.2-3 1.2-2.5 0-3.8-1.3-4.6-2.2l-2.5 2.6c1.5 1.7 4.2 3.1 7.2 3.1s5.3-1.1 6.6-3c.8-1.1 1.2-2.5 1.3-4.7V14.2h-3.8v1.2Zm-.1 8.4c-.8 1.1-2.1 1.8-3.6 1.8-2.2 0-3.9-1.7-3.9-4.1s1.5-4.1 3.8-4.1 2.9.7 3.7 1.8v4.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgSgpTag as ReactComponent };
